import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: auto;
  position: absolute;
  right: 9rem;
  padding-top: 0.2rem;
`;
